<template>
  <DetailTemplate
    :customClass="'opportunity-detail detail-page'"
    v-if="getPermission('opportunities:view')"
  >
    <template v-slot:sidebar-detail>
      <v-card class="h-100" elevation="0">
        <div class="d-flex px-2 flex-wrap align-center">
          <!-- <Status :status="customerActivated"></Status> -->
          <v-chip
            v-if="
              opportunityData &&
              opportunityData.status !== undefined &&
              opportunityData.status !== null
            "
            :color="getOpportunityStatus.color"
            text-color="white"
            label
            class="mr-2"
          >
            <span class="font-size-16 font-weight-500">
              {{ getOpportunityStatus.text }}
            </span>
          </v-chip>
          <template v-if="detail && detail.status">
            <span class="my-1">
              <CustomStatus
                :status="detail.status"
                endpoint="opportunity/status"
              ></CustomStatus>
            </span>

            <!-- <span v-if="detail?.quotation_type">
              <v-chip
                label
                :color="getTypeAtt(detail.quotation_type, 'color')"
                text-color="white"
                class="font-weight-500"
              >
                {{ getTypeAtt(detail.quotation_type, "text") }}
              </v-chip>
            </span> -->
          </template>

          <template
            v-if="
              detail?.invoice_count &&
              detail?.invoice_count > 0 &&
              detail.status == 2
            "
          >
            <v-chip
              color="orange"
              text-color="white"
              label
              class="my-1 ml-2 text-uppercase font-weight-600"
            >
              Invoiced
            </v-chip>
          </template>
          <!-- <template
            v-if="detail.pending_for_approver == 1 && detail.status == 1"
          >
            <v-chip color="red" text-color="white" label>
              {{ detail.pending_approver }}
            </v-chip>
          </template> -->

          <!--    <v-chip
            label
            :color="getColorType(detail.type)"
            text-color="white"
            class="my-1 ml-2 text-uppercase font-weight-600"
            >{{ getColorText(detail.type) }}</v-chip
          > -->
        </div>

        <div>
          <span
            class="font-weight-bold color-custom-blue font-size-21 ml-2 my-1"
            >{{ formatMoney(opportunityData.total) }}</span
          >
        </div>
        <div class="mt-5 px-0">
          <table width="100%">
            <tr>
              <th
                colspan="2"
                class="grey lighten-4 color-custom-blue text-uppercase py-1 px-3 mb-2 text-left"
              >
                Opportunity Information
              </th>
            </tr>
            <tr>
              <td
                valign="middle"
                width="160"
                class="py-1 font-size-18 font-weight-500 border-bottom-dashed"
              >
                Opportunity #
              </td>
              <td
                valign="middle"
                class="py-1 font-size-18 border-bottom-dashed"
              >
                <v-chip
                  label
                  color="chip-custom-blue"
                  outlined
                  class="text-white px-3 font-weight-600"
                  small
                  >{{ opportunityData.barcode }}
                </v-chip>
              </td>
            </tr>
            <tr>
              <td
                valign="middle"
                width="160"
                class="py-1 font-size-18 font-weight-500 border-bottom-dashed"
              >
                Opportunity Type
              </td>
              <td
                valign="middle"
                class="py-1 font-size-18 border-bottom-dashed text-uppercase font-weight-600"
              >
                {{ opportunityData.type }}
              </td>
            </tr>
            <tr v-if="detail && detail.q_duplicate_barcode">
              <td
                valign="middle"
                width="160"
                class="py-1 font-size-18 font-weight-500 border-bottom-dashed"
              >
                Duplicate From
              </td>
              <td
                valign="middle"
                class="py-1 font-size-18 border-bottom-dashed"
              >
                <Barcode
                  dense
                  small
                  :barcode="detail.q_duplicate_barcode"
                ></Barcode>
              </td>
            </tr>
            <tr v-if="detail && detail.q_requote_barcode">
              <td
                valign="middle"
                width="160"
                class="py-1 font-size-18 font-weight-500 border-bottom-dashed"
              >
                Re-Quote From
              </td>
              <td
                valign="middle"
                class="py-1 font-size-18 border-bottom-dashed"
              >
                <Barcode
                  dense
                  small
                  :barcode="detail.q_requote_barcode"
                ></Barcode>
              </td>
            </tr>
            <tr v-if="detail && detail.q_revise_barcode">
              <td
                valign="middle"
                width="160"
                class="py-1 font-size-18 font-weight-500 border-bottom-dashed"
              >
                Revise From
              </td>
              <td
                valign="middle"
                class="py-1 font-size-18 border-bottom-dashed"
              >
                <Barcode
                  dense
                  small
                  :id="detail.quotation_revise"
                  :barcode="detail.q_revise_barcode"
                  :route="'quotation.detail'"
                ></Barcode>
              </td>
            </tr>
            <tr>
              <td
                valign="middle"
                width="160"
                class="py-1 font-size-18 font-weight-500 border-bottom-dashed"
              >
                Rate opportunity
              </td>
              <td
                valign="middle"
                class="py-1 font-size-18 border-bottom-dashed"
              >
                <v-rating
                  readonly
                  dense
                  v-model="opportunityData.rating"
                  background-color="orange lighten-3"
                  color="orange"
                ></v-rating>
              </td>
            </tr>
            <tr v-if="detail.reference">
              <td
                valign="middle"
                width="160"
                class="py-1 font-size-18 font-weight-500 border-bottom-dashed"
              >
                Customer Ref/Your Ref on PDF
              </td>
              <td
                valign="middle"
                class="py-1 font-size-18 border-bottom-dashed"
              >
                <label class="m-0" v-if="detail.reference">{{
                  detail.reference
                }}</label>
                <em class="text-muted" v-else> no customer reference</em>
              </td>
            </tr>

            <tr v-if="detail.quotation_category">
              <td
                valign="middle"
                width="160"
                class="py-1 font-size-18 font-weight-500 border-bottom-dashed"
              >
                Quotation Category
              </td>
              <td
                valign="middle"
                class="py-1 font-size-18 border-bottom-dashed"
              >
                <label class="m-0">
                  {{ detail.quotation_category }}
                </label>
              </td>
            </tr>

            <tr v-if="detail.quotation_subcategory">
              <td
                valign="middle"
                width="160"
                class="py-1 font-size-18 font-weight-500 border-bottom-dashed"
              >
                Quotation Subcategory
              </td>
              <td
                valign="middle"
                class="py-1 font-size-18 border-bottom-dashed"
              >
                <label class="m-0">
                  {{ detail.quotation_subcategory }}
                </label>
              </td>
            </tr>
            <tr v-if="detail.your_reference">
              <td
                valign="middle"
                width="160"
                class="py-1 font-size-18 font-weight-500 border-bottom-dashed"
              >
                Internal Reference #
              </td>
              <td
                valign="middle"
                class="py-1 font-size-18 border-bottom-dashed"
              >
                <label class="m-0" v-if="detail.your_reference">{{
                  detail.your_reference
                }}</label>
                <em class="text-muted" v-else> no internal reference</em>
              </td>
            </tr>
            <tr v-if="detail.sales_user">
              <td
                valign="middle"
                width="160"
                class="py-1 font-size-18 font-weight-500 border-bottom-dashed"
              >
                PIC
              </td>
              <td
                valign="middle"
                class="py-1 font-size-18 border-bottom-dashed"
              >
                <label class="m-0"
                  ><router-link
                    :to="{
                      name: 'admin.user.detail',
                      params: { id: detail.sales_user.id },
                    }"
                    ><v-chip
                      v-if="
                        detail &&
                        detail.sales_user &&
                        detail.sales_user.display_name
                      "
                      small
                      class="mb-1 mr-1"
                    >
                      <v-avatar left small>
                        <img
                          v-if="
                            detail.sales_user &&
                            detail.sales_user.profile_logo &&
                            detail.sales_user.profile_logo.file
                          "
                          :src="detail.sales_user.profile_logo.file.url"
                        />
                        <img
                          v-else
                          src="https://ams-dev.businessthrust.com//media/misc/no_photo_found.png"
                        />
                      </v-avatar>
                      <span>{{ detail.sales_user.display_name }}</span>
                    </v-chip></router-link
                  ></label
                >
              </td>
            </tr>
            <tr v-if="detail.prepared_user">
              <td
                valign="middle"
                width="160"
                class="py-1 font-size-18 font-weight-500 border-bottom-dashed"
              >
                Prepared by
              </td>
              <td
                valign="middle"
                class="py-1 font-size-18 border-bottom-dashed"
              >
                <label class="m-0"
                  ><router-link
                    :to="{
                      name: 'admin.user.detail',
                      params: { id: detail.prepared_user.id },
                    }"
                  >
                    <v-chip
                      v-if="
                        detail &&
                        detail.prepared_user &&
                        detail.prepared_user.display_name
                      "
                      small
                      class="mb-1 mr-1"
                    >
                      <v-avatar left small>
                        <img
                          v-if="
                            detail.prepared_user &&
                            detail.prepared_user.profile_logo &&
                            detail.prepared_user.profile_logo.file
                          "
                          :src="detail.prepared_user.profile_logo.file.url"
                        />
                        <img
                          v-else
                          src="https://ams-dev.businessthrust.com//media/misc/no_photo_found.png"
                        />
                      </v-avatar>
                      <span>{{ detail.prepared_user.display_name }}</span>
                    </v-chip>
                  </router-link></label
                >
              </td>
            </tr>
            <tr v-if="detail.added_at">
              <td
                valign="middle"
                width="160"
                class="py-1 font-size-18 font-weight-500 border-bottom-dashed"
              >
                Created
              </td>
              <td
                valign="middle"
                class="py-1 font-size-18 border-bottom-dashed"
              >
                <label class="m-0">
                  {{ formatDate(detail.added_at) }}
                </label>
              </td>
            </tr>
            <tr v-if="detail.validity_till && detail.validity_till > 0">
              <td
                valign="middle"
                width="160"
                class="py-1 font-size-18 font-weight-500 border-bottom-dashed"
              >
                Validity
              </td>
              <td
                valign="middle"
                class="py-1 font-size-18 border-bottom-dashed"
              >
                <label class="m-0">
                  {{ getValidityDate(detail.validity_till) }}
                  <span class="red--text font-weight-600">
                    ({{ detail.validity_till }} Days)
                  </span>
                </label>
              </td>
            </tr>
            <tr>
              <td valign="middle" class="py-1 font-size-18 font-weight-500">
                Related ID
              </td>
              <td valign="middle" class="py-1 font-size-18">
                <Barcode
                  v-if="opportunityData.lead && opportunityData.lead.barcode"
                  route="lead.detail"
                  :id="opportunityData.lead.id"
                  :barcode="opportunityData.lead.barcode"
                  small
                ></Barcode>
                <Barcode
                  v-else-if="
                    opportunityData.customer_data &&
                    opportunityData.customer_data.barcode
                  "
                  route="customer.detail"
                  :id="opportunityData.customer_data.id"
                  :barcode="opportunityData.customer_data.barcode"
                  small
                ></Barcode>
                <template v-else>-</template>
              </td>
            </tr>

            <tr v-if="detail?.approved_reject_remarks">
              <th
                colspan="2"
                class="grey lighten-4 color-custom-blue text-uppercase py-2 px-3 mt-4 mb-2 text-left"
              >
                Approved Remark
              </th>
            </tr>
            <tr v-if="detail?.approved_reject_remarks">
              <td valign="middle" colspan="2" class="py-1 font-size-18">
                {{ detail.approved_reject_remarks }}
              </td>
            </tr>
            <tr v-if="detail?.unapproved_remark">
              <th
                colspan="2"
                class="grey lighten-4 color-custom-blue text-uppercase py-2 px-3 mt-4 mb-2 text-left"
              >
                Unapproved Remark
              </th>
            </tr>
            <tr v-if="detail?.unapproved_remark">
              <td valign="middle" colspan="2" class="py-1 font-size-18">
                {{ detail.unapproved_remark }}
              </td>
            </tr>
            <tr v-if="detail.fax && false">
              <td valign="middle" class="py-1 font-size-18 font-weight-600">
                FAX
              </td>
              <td valign="middle" class="py-1 font-size-18 font-weight-500">
                <label class="m-0">{{ detail.fax }}</label>
              </td>
            </tr>
            <tr v-if="detail.did && false">
              <td valign="middle" class="py-1 font-size-18 font-weight-600">
                DID
              </td>
              <td valign="middle" class="py-1 font-size-18 font-weight-500">
                <label class="m-0">{{ detail.did }}</label>
              </td>
            </tr>

            <tr v-if="false && detail.approved_user">
              <td valign="middle" class="py-1 font-size-18 font-weight-500">
                Approved by
              </td>
              <td valign="middle" class="py-1 font-size-18">
                <label class="m-0"
                  ><router-link
                    :to="{
                      name: 'admin.user.detail',
                      params: { id: detail.approved_user.id },
                    }"
                    >{{ detail.approved_user.display_name }}</router-link
                  ></label
                >
              </td>
            </tr>

            <tr v-if="detail.approved_reject_remarks && false">
              <td
                valign="middle"
                class="py-1 font-size-18 font-weight-500 d-flex"
              >
                Rejected Remark
              </td>
              <td valign="middle" class="py-1 font-size-18">
                <label class="m-0">{{ detail.approved_reject_remarks }}</label>
              </td>
            </tr>
            <tr v-if="detail.accepted_remarks && false">
              <td
                valign="middle"
                class="py-1 font-size-18 font-weight-500 d-flex"
              >
                Accepted Remark
              </td>
              <td valign="middle" class="py-1 font-size-18">
                <label class="m-0">{{ detail.accepted_remarks }}</label>
              </td>
            </tr>
            <tr v-if="false && detail.approved_date">
              <td valign="middle" class="py-1 font-size-18 font-weight-500">
                Accepted Date
              </td>
              <td valign="middle" class="py-1 font-size-18">
                <label class="m-0">{{ detail.approved_date }}</label>
              </td>
            </tr>
            <tr
              v-if="
                detail &&
                detail.ticket_multiple &&
                detail.ticket_multiple.length > 0 &&
                false
              "
            >
              <td valign="middle" class="py-1 font-size-18 font-weight-500">
                Visit Id
              </td>
              <td valign="middle" class="py-1 font-size-18">
                <label class="m-0">
                  <template v-for="(row, index) in detail.ticket_multiple">
                    <span :key="index">
                      <v-chip
                        label
                        :color="getColor(row.visit[0].status_text)"
                        class="text-white p-2 mr-2"
                        small
                        v-on:click="routeToVisit(row.visit[0].id)"
                      >
                        {{ row.visit[0].barcode }}
                      </v-chip>
                      <!--   <v-chip outlined color="cyan" class="text-white">
                                {{ row.visit[0].barcode }} 
                              </v-chip> -->
                    </span>
                  </template>
                </label>
              </td>
            </tr>
            <tr v-if="false && detail.is_contract">
              <td valign="middle" class="py-1 font-size-18 font-weight-500">
                Is Contract ?
              </td>
              <td valign="middle" class="py-1 font-size-18">
                <label class="m-0">{{
                  detail.is_contract ? "Yes" : "No"
                }}</label>
              </td>
            </tr>
            <tr v-if="detail.is_contract">
              <th
                colspan="2"
                class="grey lighten-4 font-size-16 text-uppercase color-custom-blue py-1"
              >
                Contract Information
              </th>
            </tr>
            <tr v-if="detail.is_contract">
              <td
                width="100%"
                colspan="2"
                valign="middle"
                class="py-1 font-size-18 font-weight-700"
              >
                This Contract will start on
                {{ formatDate(detail.contract_start) }} and finish on
                {{ formatDate(detail.contract_end) }}
              </td>
            </tr>
            <tr v-if="detail.is_contract">
              <td valign="middle" class="py-1 font-size-18 font-weight-500">
                No. of Service Trips
              </td>
              <td valign="middle" class="py-1 font-size-18">
                <label class="m-0"
                  >{{ detail.total_service }}
                  <template v-if="detail.base_type == 'service_no'">
                    <span class="font-weight-600">(Services)</span>
                  </template>
                  <template v-else>
                    <span class="text-capitalize font-weight-600"
                      >({{ detail.base_type }})</span
                    >
                  </template>
                </label>
              </td>
            </tr>
            <tr v-if="detail.is_contract">
              <td valign="middle" class="py-1 font-size-18 font-weight-500">
                Billing Option
              </td>
              <td valign="middle" class="py-1 font-size-18">
                <label class="m-0">
                  {{ detail.billing_option }}
                </label>
              </td>
            </tr>
            <template
              v-if="detail.invoice_needed && is_quotation_invoice_allow"
            >
              <tr v-if="detail.invoice_needed">
                <th
                  colspan="2"
                  class="grey lighten-4 font-size-16 text-uppercase color-custom-blue py-1"
                >
                  Invoicing
                </th>
              </tr>
              <tr v-if="detail?.invoice_needed">
                <td valign="middle" class="py-1 font-size-18 font-weight-500">
                  Is Invoice Needed
                </td>
                <td valign="middle" class="py-1 font-size-18">
                  <label class="m-0" v-if="detail.invoice_needed">
                    <v-chip
                      color="chip-custom-blue"
                      outlined
                      text-color=""
                      small
                      label
                    >
                      YES</v-chip
                    >
                  </label>
                  <em class="text-muted" v-else> no internal reference</em>
                </td>
              </tr>
              <tr v-if="detail?.invoice_count">
                <td valign="middle" class="py-1 font-size-18 font-weight-500">
                  Total Invoice
                </td>
                <td valign="middle" class="py-1 font-size-18">
                  <label
                    class="m-0 font-weight-700"
                    v-if="detail.invoice_count"
                  >
                    <v-badge
                      color="red"
                      class="ml-1"
                      :content="detail.invoice_count"
                    ></v-badge>
                  </label>
                </td>
              </tr>
              <tr v-if="detail?.invoice_type">
                <td valign="middle" class="py-1 font-size-18 font-weight-500">
                  Invoice Type
                </td>
                <td valign="middle" class="py-1 font-size-18">
                  <label class="m-0" v-if="detail?.invoice_type">
                    <v-chip
                      color="chip-custom-blue"
                      class="text-capitalize"
                      outlined
                      text-color=""
                      small
                      label
                    >
                      {{ detail?.invoice_type }}</v-chip
                    >
                  </label>
                </td>
              </tr>
              <tr
                v-if="
                  detail?.invoice_date && detail?.invoice_type != 'recurring'
                "
              >
                <td valign="middle" class="py-1 font-size-18 font-weight-500">
                  Invoice Date
                </td>
                <td valign="middle" class="py-1 font-size-18">
                  <label class="m-0" v-if="detail?.invoice_date">
                    <v-chip
                      color="chip-custom-blue"
                      class="text-capitalize"
                      outlined
                      text-color=""
                      small
                      label
                    >
                      {{ formatDate(detail?.invoice_date) }}</v-chip
                    >
                  </label>
                </td>
              </tr>
              <tr v-if="detail?.payment_due">
                <td valign="middle" class="py-1 font-size-18 font-weight-500">
                  Payment Due
                </td>
                <td valign="middle" class="py-1 font-size-18">
                  <label class="m-0 font-weight-700" v-if="detail?.payment_due">
                    {{ getDueDay(detail?.payment_due) }} NET
                  </label>
                </td>
              </tr>
              <tr v-if="detail?.invoice_needed">
                <td
                  valign="middle"
                  class="py-1 font-size-18 font-weight-500 d-flex"
                >
                  Invoice Creation
                </td>
                <td valign="middle" class="py-1 font-size-18">
                  <label
                    class="m-0 font-weight-700"
                    v-if="detail.invoice_main_type"
                  >
                    <template
                      v-if="
                        detail.invoice_main_type == 'auto_create_on_acceptance'
                      "
                    >
                      Auto create on quote acceptance
                    </template>
                    <template v-else>
                      Auto create and send on quote acceptance
                    </template>
                  </label>
                </td>
              </tr>
              <tr
                v-if="
                  detail?.invoice_criteria &&
                  detail?.invoice_type == 'recurring'
                "
              >
                <td
                  valign="middle"
                  class="py-1 font-size-18 font-weight-500 d-flex"
                >
                  Invoice criteria
                </td>
                <td valign="middle" class="py-1 font-size-18">
                  <label
                    class="m-0 font-weight-700"
                    v-if="detail.invoice_criteria"
                  >
                    <template v-if="detail.invoice_criteria == 'total_amount'">
                      Generate all invoices for the quote amount.
                    </template>
                    <template v-else>
                      Generate all invoices for (1/No. of Schedule) the quote
                      amount
                    </template>
                  </label>
                </td>
              </tr>
            </template>
          </table>
        </div>
      </v-card>
    </template>
    <template v-slot:header-title>
      <v-skeleton-loader
        class="custom-skeleton"
        v-if="pageLoading"
        width="400"
        height="28"
        type="text"
      >
      </v-skeleton-loader>
      <div class="d-flex align-items-center">
        <v-tooltip
          max-width="500"
          top
          content-class="custom-top-tooltip"
          :disabled="!opportunityData.title"
        >
          <template v-slot:activator="{ on, attrs }">
            <h1
              v-bind="attrs"
              v-on="on"
              class="form-title custom-nowrap-ellipsis text-capitalize mr-2"
            >
              {{ opportunityData.title }} • {{ opportunityData.barcode }}
            </h1>
          </template>
          <span
            >{{ opportunityData.title }} • {{ opportunityData.barcode }}</span
          >
        </v-tooltip>

        <v-chip
          v-if="false"
          label
          color="chip-custom-blue"
          outlined
          class="text-white p-3 mr-4"
          style="font-size: 21px !important; font-weight: 700"
        >
          {{ opportunityData.barcode }}
        </v-chip>
      </div>
    </template>
    <template v-slot:header-action>
      <v-menu
        v-if="
          getPermission('opportunities:update') &&
          Number(opportunityData.status) === 1
        "
        content-class="custom-menu-list"
        bottom
        offset-y
        left
        transition="slide-y-transition"
        :close-on-click="true"
      >
        <template v-slot:activator="{ on, attrs }">
          <v-btn
            depressed
            :disabled="pageLoading || statusLoading"
            :loading="statusLoading"
            class="mx-1 custom-bold-button white--text"
            color="cyan"
            v-bind="attrs"
            v-on="on"
          >
            More... <v-icon right>mdi-chevron-down</v-icon>
          </v-btn>
        </template>
        <v-list>
          <v-list-item
            v-for="item in opportunityStatusActions"
            :key="item.action"
            link
            v-on:click="updateOpportunityStatus(item.action)"
          >
            <v-list-item-icon class="margin-auto-zero mr-3 my-2">
              <v-icon class="icon-default-blue">{{ item.icon }}</v-icon>
            </v-list-item-icon>
            <v-list-item-title class="font-weight-500 font-size-14">
              {{ item.title }}
            </v-list-item-title>
          </v-list-item>
        </v-list>
      </v-menu>
      <template
        v-if="
          getPermission('quotation:create') &&
          (opportunityData.lead_id || opportunityData.customer) &&
          ![1, 3, 4].includes(Number(opportunityData.status))
        "
      >
        <v-tooltip bottom content-class="custom-bottom-tooltip">
          <template v-slot:activator="{ on, attrs }">
            <v-btn
              depressed
              :disabled="pageLoading"
              class="mx-1 custom-bold-button white--text"
              color="cyan"
              v-bind="attrs"
              v-on="on"
              v-on:click="
                convertQuotation(opportunityData, 'convert_to_quotation')
              "
            >
              <v-icon>mdi-file-certificate-outline</v-icon> Convert to Quotation
            </v-btn>
          </template>
          <span>Click here to Convert to Quotation</span>
        </v-tooltip>
      </template>
      <v-btn
        class="mx-2 custom-grey-border custom-bold-button"
        v-on:click="goBack"
        depressed
      >
        <v-icon small left>mdi-keyboard-backspace</v-icon>
        Back
      </v-btn>
      <v-btn
        v-if="
          getPermission('opportunities:update') &&
          Number(opportunityData.status) === 1
        "
        class="mx-2 custom-bold-button white--text"
        color="cyan"
        depressed
        v-on:click="editOpportunity"
      >
        <v-icon left>mdi-pencil</v-icon>Edit Opportunity
      </v-btn>
    </template>

    <template v-slot:body>
      <v-container fluid class="px-0">
        <v-tabs
          active-class="custom-tab-active"
          v-model="opportunityTab"
          background-color="transparent"
          color="cyan"
          class="custom-tab-transparent tab-sticky"
        >
          <v-tab class="font-size-16 font-weight-600 px-8" href="#other">
            <span class="svg-icon svg-icon-lg mr-4 svg-v-list-icon">
              <!--begin::Svg Icon-->
              <inline-svg :src="$assetURL('media/custom-svg/property.svg')" />
              <!--end::Svg Icon-->
            </span>
            Overview
          </v-tab>
          <v-tab class="font-size-16 font-weight-600 px-8" href="#line-item">
            <span class="svg-icon svg-icon-lg mr-4 svg-v-list-icon">
              <!--begin::Svg Icon-->
              <inline-svg :src="$assetURL('media/custom-svg/line-item.svg')" />
              <!--end::Svg Icon-->
            </span>
            Line Items
          </v-tab>
          <v-tab class="font-size-16 font-weight-600 px-8" href="#meetings">
            <span class="svg-icon svg-icon-lg mr-4 svg-v-list-icon">
              <!--begin::Svg Icon-->
              <inline-svg :src="$assetURL('media/custom-svg/staff.svg')" />
              <!--end::Svg Icon-->
            </span>
            Meetings
          </v-tab>
          <v-tab class="font-size-16 font-weight-600 px-8" href="#attachments">
            <span class="svg-icon svg-icon-lg mr-4 svg-v-list-icon">
              <!--begin::Svg Icon-->
              <inline-svg :src="$assetURL('media/custom-svg/attachment.svg')" />
              <!--end::Svg Icon-->
            </span>
            Attachments
          </v-tab>
          <v-tab class="font-size-16 font-weight-600 px-8" href="#history">
            <span class="svg-icon svg-icon-lg mr-4 svg-v-list-icon">
              <!--begin::Svg Icon-->
              <inline-svg :src="$assetURL('media/custom-svg/history.svg')" />
              <!--end::Svg Icon-->
            </span>
            History
          </v-tab>
          <v-tab class="font-size-16 font-weight-600 px-8" href="#follow-up">
            <span class="svg-icon svg-icon-lg mr-4 svg-v-list-icon">
              <!--begin::Svg Icon-->
              <inline-svg :src="$assetURL('media/custom-svg/budget.svg')" />
              <!--end::Svg Icon-->
            </span>
            Follow up
          </v-tab>
        </v-tabs>
        <v-tabs-items v-model="opportunityTab">
          <v-tab-item value="other">
            <v-container fluid class="px-0">
              <!-- Basic Information Card -->
              <v-card outlined elevation="0" class="mb-4">
                <div
                  class="grey lighten-5 d-flex align-center justify-space-between px-4 py-3 border-bottom"
                >
                  <div class="d-flex align-center">
                    <v-icon color="blue darken-2" small class="mr-2"
                      >mdi-information-outline</v-icon
                    >
                    <h3
                      class="font-weight-700 color-custom-blue font-size-18 mb-0 text-uppercase"
                    >
                      Basic Information
                    </h3>
                  </div>
                </div>
                <v-card-text class="pa-4 font-size-16">
                  <table class="width-100">
                    <tr>
                      <td
                        width="200"
                        class="py-1 font-size-18 font-weight-500 border-bottom-dashed"
                      >
                        Title
                      </td>
                      <td
                        class="font-size-18 py-1 border-bottom-dashed text-lowercase"
                      >
                        {{ opportunityData.title }}
                      </td>
                    </tr>
                    <tr>
                      <td
                        width="200"
                        class="py-1 font-size-18 font-weight-500 border-bottom-dashed"
                      >
                        Source
                      </td>
                      <td
                        class="font-size-18 py-1 border-bottom-dashed text-lowercase"
                      >
                        {{ opportunityData.source }}
                      </td>
                    </tr>
                    <tr>
                      <td
                        width="200"
                        class="py-1 font-size-18 font-weight-500 border-bottom-dashed"
                      >
                        Opportunity
                      </td>
                      <td
                        class="font-size-18 py-1 border-bottom-dashed text-lowercase"
                      >
                        {{ opportunityData.opportunity_text }}
                      </td>
                    </tr>
                    <tr>
                      <td
                        width="200"
                        class="py-1 font-size-18 font-weight-500 border-bottom-dashed"
                      >
                        Opportunity Date
                      </td>
                      <td
                        class="font-size-18 py-1 border-bottom-dashed text-lowercase"
                      >
                        {{ formatDate(opportunityData.opportunity_date) }}
                      </td>
                    </tr>
                    <tr v-if="opportunityData.remark">
                      <td width="200" class="py-1 font-size-18 font-weight-500">
                        Remark
                      </td>
                      <td
                        class="font-size-18 py-1 text-lowercase"
                        style="overflow-wrap: anywhere; word-break: break-word"
                      >
                        {{ opportunityData.remark }}
                      </td>
                    </tr>
                  </table>
                </v-card-text>
              </v-card>

              <!-- Notes Card -->
              <v-card outlined elevation="0" class="mb-4">
                <div
                  class="grey lighten-5 d-flex align-center justify-space-between px-4 py-3 border-bottom"
                >
                  <div class="d-flex align-center">
                    <v-icon color="cyan darken-2" small class="mr-2"
                      >mdi-note-text-outline</v-icon
                    >
                    <h3
                      class="font-weight-700 color-custom-blue font-size-18 mb-0 text-uppercase"
                    >
                      Notes
                    </h3>
                  </div>
                </div>

                <v-card-text class="pa-4 font-size-16">
                  <div v-if="opportunityData && opportunityData.admin_note">
                    <read-more
                      class="custom-read-more font-weight-600 font-size-18 pb-1 custom-gray-color"
                      more-str="read more"
                      less-str="read less"
                      :text="opportunityData.admin_note || '<em>No Notes</em>'"
                      link="#"
                      :max-chars="200"
                    />
                  </div>

                  <div v-else>
                    <em class="text-muted">No Notes</em>
                  </div>
                </v-card-text>
              </v-card>
            </v-container>
          </v-tab-item>
          <v-tab-item value="line-item">
            <!--   <pre>{{ detail }}</pre> -->
            <OpportunityLineItem
              :show-price="opportunityData.show_price"
              v-on:line-item="lengthCount"
              :discount-level="
                opportunityData.discount_type == 2 ? 'line_item' : 'transaction'
              "
              :related-id="opportunityId"
              :related-type="9"
              is-opportunity
            />
            <div class="mt-0 pr-2 font-weight-600">
              <table width="100%">
                <tr>
                  <td width="66%" class="py-1"></td>
                  <td width="18%" align="right" class="py-1">Sub Total</td>
                  <td width="18%" align="right" class="py-1">
                    {{ formatMoney(opportunityData.sub_total) }}
                  </td>
                </tr>
                <tr v-if="opportunityData.discount_type == 1">
                  <td class="py-1"></td>
                  <td align="right" class="py-1">
                    Discount
                    <span v-if="detail.discount_value_type == 1"
                      >({{ formatMoney(opportunityData.discount_value) }})</span
                    >
                    <span v-if="detail.discount_value_type == 2"
                      >({{
                        formatNumber(opportunityData.discount_value)
                      }}%)</span
                    >
                  </td>
                  <td align="right" class="py-1">
                    {{ formatMoney(opportunityData.discount_amount) }}
                  </td>
                </tr>
                <tr v-if="opportunityData.tax_applied">
                  <td class="py-1"></td>
                  <td class="py-1" align="right">
                    Tax [GST {{ opportunityData.tax_value }}%]
                  </td>
                  <td class="py-1" align="right">
                    {{ formatMoney(opportunityData.tax_amount) }}
                  </td>
                </tr>
                <tr>
                  <td class="py-1"></td>
                  <td class="py-1" align="right">Adjustment</td>
                  <td class="py-1" align="right">
                    {{ formatMoney(opportunityData.adjustment) }}
                  </td>
                </tr>
                <tr class="font-size-19">
                  <td class="py-1"></td>
                  <td class="py-1" align="right">Grand Total</td>
                  <td
                    class="py-1 font-weight-bold color-custom-blue"
                    align="right"
                  >
                    {{ formatMoney(opportunityData.total) }}
                  </td>
                </tr>
              </table>
            </div>
          </v-tab-item>
          <v-tab-item v-if="getPermission('customer:view')" :value="'meetings'">
            <MeetingDetails
              :type="2"
              :relatedTo="'Opportunity'"
              :parentId="opportunityId"
              :assigneeList="opportunityData?.userList"
            />
          </v-tab-item>
          <v-tab-item value="attachments">
            <AdditionalDocuments
              :type-id="opportunityData.id"
              class="mx-4"
              type-text="Opportunity Attachments"
              :type="21"
              :extensive="false"
            >
            </AdditionalDocuments>
          </v-tab-item>
          <v-tab-item value="history">
            <InternalHistoryDetail
              type="opportunity"
              :type_id="opportunityData.id"
            ></InternalHistoryDetail>
          </v-tab-item>
          <v-tab-item value="follow-up">
            <v-row no-gutters>
              <v-col cols="6" class="margin-auto">
                <h2 class="margin-auto color-custom-blue font-weight-600">
                  Follow up
                </h2>
              </v-col>
              <v-col cols="6">
                <span>
                  <template>
                    <span class="float-right">
                      <v-skeleton-loader
                        class="custom-skeleton d-inline-block custom-skeleton-full-width"
                        v-if="pageLoading"
                        type="button"
                        height="28"
                        width="200"
                      >
                      </v-skeleton-loader>
                      <v-btn
                        depressed
                        v-else
                        class="mx-2 mr-4 custom-bold-button white--text"
                        color="cyan"
                        small
                        v-on:click.native.stop="createFollowUp"
                      >
                        <v-icon dark left>mdi-plus</v-icon>Create Follow up
                      </v-btn>
                    </span>
                  </template>
                </span>
              </v-col>
            </v-row>
            <v-col cols="12" class="pa-0">
              <FollowUp
                :pageLoading="pageLoading"
                :opportunity="opportunityData"
                v-on:refress:data="getOpportunity"
                v-on:success="getOpportunity"
              ></FollowUp>
            </v-col>
          </v-tab-item>
        </v-tabs-items>
        <Dialog :common-dialog="followUpDialog" :dialog-width="600">
          <template v-slot:title> Create Follow Up </template>

          <template v-slot:body>
            <v-form ref="followUpFormRef" v-model="followUpValid">
              <v-container>
                <label class="my-auto fw-500 required mb-1"
                  >Follow Up Date</label
                >
                <DatePicker
                  solo
                  flat
                  placeholder="Follow Up Date"
                  :min-date="todayDate"
                  :rules="[
                    validateRules.required(
                      followUpForm.follow_up_date,
                      'Follow Up Date'
                    ),
                  ]"
                  v-model="followUpForm.follow_up_date"
                >
                </DatePicker>

                <label class="my-auto fw-500 required mb-1">Type</label>
                <v-select
                  v-model="followUpForm.type"
                  :items="types"
                  :rules="[validateRules.required(followUpForm.type, 'Type')]"
                  dense
                  flat
                  solo
                  filled
                  item-value="value"
                  item-text="text"
                />

                <label class="my-auto fw-500 required mb-1">Remark</label>

                <v-textarea
                  v-model.trim="followUpForm.remark"
                  auto-grow
                  dense
                  filled
                  color="cyan"
                  placeholder="Remark"
                  solo
                  flat
                  :rules="[
                    validateRules.required(followUpForm.remark, 'Remark'),
                    validateRules.minLength(followUpForm.remark, 'Remark', 1),
                    validateRules.maxLength(followUpForm.remark, 'Remark', 150),
                  ]"
                  v-on:keypress="(e) => manageLimit(e, 150)"
                  v-on:paste="(e) => onPaste(e, 150)"
                  row-height="15"
                ></v-textarea>
                <div class="d-flex justify-end">
                  {{
                    followUpForm &&
                    followUpForm.remark &&
                    followUpForm.remark.length
                      ? followUpForm.remark.length
                      : 0
                  }}/150
                </div>

                <label class="my-auto fw-500 mb-1">Next Follow Up Date</label>
                <DatePicker
                  solo
                  flat
                  placeholder="Next Follow Up Date"
                  :min-date="followUpForm.follow_up_date || todayDate"
                  v-model="followUpForm.next_follow_up_date"
                >
                </DatePicker>
              </v-container>
            </v-form>
          </template>

          <template v-slot:action>
            <v-btn
              color="cyan"
              class="white--text"
              :disabled="!followUpValid"
              :loading="followUpLoading"
              @click="submitFollowUp"
            >
              Submit
            </v-btn>

            <v-btn @click="closeFollowUpDialog"> Cancel </v-btn>
          </template>
        </Dialog>
      </v-container>
    </template>
  </DetailTemplate>
</template>

<script>
import CommonMixin from "@/core/plugins/common-mixin";
import { SET_BREADCRUMB } from "@/core/services/store/breadcrumbs.module";
import { GET, PATCH, POST, PUT } from "@/core/services/store/request.module";
import DetailTemplate from "@/view/pages/partials/Detail-Template.vue";
import OpportunityLineItem from "@/view/components/VisitLineItem.vue";
import AdditionalDocuments from "@/view/pages/engineer/Additional-Documents";
import InternalHistoryDetail from "@/view/pages/partials/Detail/Internal-History-Detail.vue";
import moment from "moment-timezone";
import Dialog from "@/view/pages/partials/Dialog.vue";
import FollowUp from "@/view/pages/lead-new/detail/overview/Follow-Up.vue";
import DatePicker from "@/view/components/QDatePicker.vue";
import { ErrorEventBus } from "@/core/lib/message.lib";
import ValidationMixin from "@/core/plugins/validation-mixin";
import { v4 as uuidv4 } from "uuid";
import MeetingDetails from "@/view/components/MeetingDetails.vue";
import Barcode from "@/view/pages/partials/Barcode.vue";

export default {
  mixins: [CommonMixin, ValidationMixin],
  name: "opportunity-detail",
  title: "Opportunity Detail",
  components: {
    DetailTemplate,
    OpportunityLineItem,
    AdditionalDocuments,
    InternalHistoryDetail,
    Dialog,
    MeetingDetails,
    FollowUp,
    DatePicker,
    Barcode,
  },
  data() {
    return {
      notesDialog: false,
      jobType: "one-off",
      typeConfirmDialog: false,
      formLoading: false,
      is_quotation_invoice_allow: false,
      quotationId: 0,
      pageLoaded: false,
      statusLoading: false,
      mail_dialog: false,
      invoiceLoading: false,
      deleteQuotationDialog: false,
      pageLoading: false,
      todayDate: null,
      DatePicker: false,
      deleteQuotationLoading: false,
      ValidDatePicker: false,
      signature: 0,
      confirm_loading: false,
      visit_count_dialog: false,
      download_template: "HYC_Pn_Inst",
      download_dialog: false,
      confirm_dialog: false,
      download_date: moment().format("YYYY-MM-DD"),
      //valid_till: moment().format("YYYY-MM-DD"),
      valid_till: moment().add(14, "days").format("YYYY-MM-DD"),
      confirm_type: null,
      payment_in_milestones: false,
      moreActions: [],
      opportunityStatusActions: [
        {
          title: "Mark as Accepted",
          action: "Accepted",
          icon: "mdi-check-all",
        },
        {
          title: "Mark as Rejected",
          action: "Rejected",
          icon: "mdi-close-circle-outline",
        },
      ],
      detail: {},
      db_approval: {},
      dbLineItems: [],
      dbEquipments: [],
      confirm: false,
      templateList: [],
      actionData: {
        remark: null,
        attachments: [],
        status: null,
      },
      userDetails: new Object(),
      attachments: [],
      profeinstaservice: {
        profe_insta_service: null,
        quotation: null,
      },
      budgetDialog: false,
      editBudgetData: null,
      budgets: [],
      budgetSelectedRows: [],
      budgetStatuses: [],
      budgetStatusDialog: false,
      selectedBudgetStatus: null,
      budgetBulkActions: [
        { text: "Pending", value: 1, color: "orange", activated: true },
        { text: "Approved", value: 2, color: "green", activated: true },
        { text: "Rejected", value: 3, color: "red", activated: true },

        // {
        //   title: "Change Status",
        //   action: "change_status",
        // },
      ],
      types: [
        {
          text: "Call",
          value: "Call",
        },
        {
          text: "Message",
          value: "Message",
        },
        {
          text: "WhatsApp",
          value: "WhatsApp",
        },
        {
          text: "Visit",
          value: "Visit",
        },
      ],

      opportunityData: {},
      opportunityId: 0,

      followUpDialog: false,
      followUpForm: {
        follow_up_date: null,
        type: null,
        remark: "",
        next_follow_up_date: null,
      },
      followUpValid: false,
      followUpLoading: false,
    };
  },
  methods: {
    updateOpportunityStatus(status) {
      this.statusLoading = true;
      this.$store
        .dispatch(PATCH, {
          url: "opportunities/status",
          data: {
            opportunity: [Number(this.opportunityId)],
            status,
          },
        })
        .then(() => this.getOpportunity())
        .catch((error) => {
          this.logError(error);
        })
        .finally(() => {
          this.statusLoading = false;
        });
    },
    lengthCount(param) {
      this.itemCount = param;
    },
    getOpportunity() {
      this.pageLoading = true;
      this.$store
        .dispatch(GET, {
          url: `opportunity/${this.opportunityId}`,
        })
        .then((response) => {
          this.opportunityData = response.data;
          const isCustomer = this.opportunityData.type === "customer";

          this.$store.dispatch(SET_BREADCRUMB, [
            // {
            //   title: isCustomer ? "Customer" : "Lead",
            //   route: isCustomer ? "customer" : "lead",
            // },
            { title: "Opportunity" },
            {
              title: "Detail",
              route: {
                name: isCustomer
                  ? "admin.customer.detail"
                  : "admin.lead.detail",
                params: {
                  id: isCustomer
                    ? this.opportunityData.customer_id
                    : this.opportunityData.lead_id,
                },
              },
            },

            { title: this.opportunityData.barcode },
          ]);
        })
        .catch(() => {
          this.goBack();
        })
        .finally(() => {
          this.pageLoading = false;
        });
    },
    // editOpportunity() {
    //   this.$router.push(
    //     this.getDefaultRoute("opportunity.create", {
    //       query: {
    //         edit: this.opportunityId,
    //         lead: this.opportunityData.lead_id,
    //       },
    //     })
    //   );
    // },

    editOpportunity() {
      const isCustomer = this.opportunityData.type === "customer";

      const query = {
        edit: this.opportunityId,
        person: this.opportunityData.contact_person,
        type: isCustomer ? "customer" : "lead",
      };

      if (isCustomer) {
        query.customer = this.opportunityData.customer;
      } else {
        query.lead = this.opportunityData.lead_id;
      }

      this.$router.push(
        this.getDefaultRoute("opportunity.create", {
          query,
        })
      );
    },
    createFollowUp() {
      this.followUpDialog = true;

      this.followUpForm = {
        follow_up_date: null,
        type: null,
        remark: "",
        next_follow_up_date: null,
      };
    },
    submitFollowUp() {
      const _this = this;

      if (!_this.$refs.followUpFormRef.validate()) return;

      _this.followUpLoading = true;

      _this.$store
        .dispatch(POST, {
          url: `opportunity-followup/${_this.opportunityId}`,
          data: _this.followUpForm,
        })
        .finally(() => {
          _this.followUpLoading = false;
          _this.closeFollowUpDialog();
          _this.getOpportunity();
        });
    },
    closeFollowUpDialog() {
      this.followUpDialog = false;

      this.$nextTick(() => {
        this.$refs.followUpFormRef?.reset();
        this.$refs.followUpFormRef?.resetValidation();
      });
    },
    createCustomerDefaultAddress(customerId, leadData = null) {
      const _this = this;
      const lead = leadData || _this.opportunityData?.lead || {};
      const defaultAddress = {
        id: null,
        contact_person: null,
        property_name:
          lead.property_name ||
          lead.street_1 ||
          lead.address_line_1 ||
          "Default Property",
        type: 1,
        is_same: 0,
        is_tenant: 0,
        unit_no: lead.unit_number || null,
        street_1: lead.address_line_1 || lead.street_1 || "Default Address",
        street_2: lead.address_line_2 || lead.street_2 || null,
        zip_code: lead.postal_code || lead.zip || "000000",
        country: lead.country || "Singapore",
        latitude: null,
        longitude: null,
        remarks: lead.remarks || null,
      };
      const billingAddress = {
        ...defaultAddress,
        type: 2,
        is_same: 1,
      };

      return _this.$store.dispatch(PUT, {
        url: `address/${customerId}`,
        data: { address: [defaultAddress, billingAddress] },
      });
    },
    manageLimit(e, limit) {
      if (
        this.followUpForm.remark &&
        this.followUpForm.remark.length >= limit
      ) {
        e.preventDefault();
      }
    },
    onPaste(e, limit) {
      const paste = (e.clipboardData || window.clipboardData).getData("text");

      if ((this.followUpForm.remark?.length || 0) + paste.length > limit) {
        e.preventDefault();
      }
    },
    convertQuotation(opportunity, param) {
      const _this = this;
      const transaction_type = _this.lodash.toString(param);

      if (transaction_type === "convert_to_quotation") {
        // If opportunity is from a lead and lead isn't converted, create customer first
        if (opportunity && opportunity.type === "lead") {
          const leadId = opportunity.lead_id || 0;
          if (leadId > 0) {
            _this.pageLoading = true;
            // fetch lead details
            _this.$store
              .dispatch(GET, { url: `leads/${leadId}` })
              .then((res) => {
                const lead = res.data;
                // If lead not converted, create customer from lead
                if (
                  lead &&
                  (lead.converted_to_customer === "0" ||
                    lead.converted_to_customer === 0)
                ) {
                  const customerPayload = {
                    entity_id: 1,
                    lead: lead.id,
                    security_code:
                      lead.security_code ||
                      Math.random()
                        .toString(36)
                        .replace(/[^A-Z0-9]/gi, "")
                        .substring(0, 8)
                        .toUpperCase(),

                    company_type: lead.company_type || "company",
                    display_name:
                      lead.display_name ||
                      lead.lead_name ||
                      lead.company_name ||
                      "",
                    company_name: lead.company_name || lead.display_name || "",
                    company_email: lead.email || lead.company_email || null,
                    company_number: lead.phone_number || null,
                    company_fax: null,
                    customer_code: null,
                    customer_class: null,
                    customer_remark: null,
                    address_line_1:
                      lead.address_line_1 || lead.street_1 || null,
                    address_line_2:
                      lead.address_line_2 || lead.street_2 || null,
                    unit_number: null,
                    postal_code: lead.postal_code || lead.zip || null,
                    website: lead.website || null,
                    uen: null,
                    country: lead.country || null,
                    state: null,
                    city: null,
                    phone: null,
                    group_id: 1,
                    client_reminders: 0,
                    client_follow_up_emails: 0,
                    print_email_on_work_order: 0,
                    primary: 1,
                    can_login: 0,
                    cust_vend_ref_no: null,
                    sap_customer_no: null,
                    category: null,
                    category_color: null,
                    sales_person: null,
                    persons: (() => {
                      const persons = (lead.persons || []).map((p) => ({
                        id: null,
                        uuid: uuidv4(),
                        type: "customer",
                        menu: p.menu || false,
                        title: p.title || "Mr",
                        first_name: p.first_name || null,
                        last_name: p.last_name || null,
                        display_name: p.display_name || p.name || null,
                        emails: p.emails || [],
                        contactIndex: p.contactIndex || null,
                        default: Number(p.default ?? p.primary) === 1 ? 1 : 0,
                        designation: p.designation || null,
                        did: p.did || null,
                        primary_email: p.primary_email || p.email || null,
                        primary_phone: p.primary_phone || p.phone || null,
                        position: p.position || p.designation || null,
                        will_notified:
                          typeof p.will_notified !== "undefined"
                            ? Number(p.will_notified)
                            : 0,
                      }));

                      return persons;
                    })(),
                  };
                  console.log(
                    "Creating customer with payload",
                    customerPayload
                  );
                  return _this.$store

                    .dispatch(POST, { url: "customer", data: customerPayload })
                    .then(() => {
                      return Promise.resolve();
                    });
                }

                // if already converted or no creation needed, resolve immediately
                return Promise.resolve();
              })
              .then(() => {
                // always navigate to quotation.create after ensuring customer exists
                _this.$router.push(
                  _this.getDefaultRoute("quotation.create", {
                    query: { opportunity: opportunity.id },
                  })
                );
              })
              .catch((err) => {
                _this.logError(err);
              })
              .finally(() => {
                _this.pageLoading = false;
              });
            return;
          }
        }

        // default: just navigate to create quotation
        _this.$router.push(
          _this.getDefaultRoute("quotation.create", {
            query: {
              opportunity: opportunity.id,
            },
          })
        );
      }
    },
  },
  watch: {
    "followUpForm.follow_up_date"(newDate) {
      if (
        this.followUpForm.next_follow_up_date &&
        new Date(this.followUpForm.next_follow_up_date) < new Date(newDate)
      ) {
        ErrorEventBus.$emit(
          "update:error",
          "Next follow date must be after follow up date"
        );
        this.followUpForm.next_follow_up_date = null;
      }
    },
  },
  created() {
    this.todayDate = moment().format("YYYY-MM-DD");
    this.opportunityId = this.$route.params.id;
    if (!this.opportunityId || this.opportunityId <= 0) {
      this.$router.go(-1);
    }
  },
  mounted() {
    this.getOpportunity();
  },
  computed: {
    getOpportunityStatus() {
      const statuses = {
        1: { text: "Draft", color: "cyan" },
        2: { text: "Accepted", color: "green" },
        3: { text: "Rejected", color: "red" },
        4: { text: "Converted to Quotation", color: "orange" },
      };

      return (
        statuses[Number(this.opportunityData.status)] || {
          text: this.opportunityData.status_text || "Unknown",
          color: "grey",
        }
      );
    },
    opportunityTab: {
      set(val) {
        let query = { ...this.$route.query };
        query.tab = val;
        if (val != this.opportunityTab) {
          this.$router.push({ query });
        }
      },
      get() {
        return this.$route.query.tab || "other";
      },
    },
  },
};
</script>

<style scoped>
.opportunity-basic-information-table {
  table-layout: fixed;
}

.opportunity-basic-information-table td {
  height: 24px;
  padding-top: 2px !important;
  padding-bottom: 2px !important;
  line-height: 20px;
}

.opportunity-basic-information-table td:first-child {
  width: 140px;
}
</style>
